"use client";

import StarrySky from "../../common/StarrySky";

type NavbarProps = {
  isMypage?: boolean;
};

export default function ImageHeader({}: NavbarProps) {
  return (
    <section className="w-full">
      {/* 星空背景 */}
      <StarrySky />

      {/* トップメッセージ */}
      <div className="pointer-events-none sticky inset-0 h-80">
        <div className="pointer-events-auto flex h-full flex-col items-center justify-center px-10 text-center md:px-5">
          <h2 className="font-noto_serif_jp text-xl text-WHITE_1 md:text-3xl">
            あなたの好きな作品の面白さを分析して、発見する場所
          </h2>
          <p className="mt-6 text-base text-WHITE_1 sm:text-xl">
            A place to analyze and discover the interesting aspects of your favorite works.
          </p>
        </div>
      </div>
    </section>
  );
}
